import React from 'react';
import {  Typography, Paper, Container } from '@mui/material';

const Datenschutzerklaerung = () => {
  return (
    <Container  maxWidth="md" sx={{ mt: 4 ,marginTop: "15vh"}}>

      <Paper sx={{ padding: 4 }}>
        <Typography variant="h5" gutterBottom>
          Datenschutzerklärung
        </Typography>

        <Typography variant="h6" gutterBottom>
          I. Allgemein
        </Typography>

        <Typography variant="body1" paragraph>
          1. Verantwortliche für die Verarbeitung
          <br />
          Die Verantwortlichen für die Verarbeitung der personenbezogenen Daten gemäß Art. 4 Nr. 7 DSGVO sind:
          <br />
Elektrokonzept
        
          <br />
          Hasan Zakour
          <br />
          65594 Runkel-Steeden
          <br />
          Schulstraße 48

          

          <br />
          info@elektrokonzept-limburg.de
        </Typography>

        

        <Typography variant="body1" paragraph>
          2. Erhebung und Verarbeitung personenbezogener Daten
          <br />
          Personenbezogene Daten werden im Rahmen dieses Internetauftritts nur im notwendigen Umfang erhoben, verarbeitet und genutzt. Beim Aufrufen unserer Webseite www.Solywelt.de werden durch den auf Ihrem Endgerät eingesetzten Browser anonymisierte Informationen an den Server unserer Website gesendet und dort temporär in einem sogenannten Logfile bis zur automatisierten Löschung gespeichert.
          <br />
          Hierbei handelt es sich um folgende Daten:
          <ul>
            <li>Ihre IP-Adresse</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>Name und URL der abgerufenen Datei</li>
            <li>Übertragene Datenmenge</li>
            <li>Zugriffsstatus/HTTP-Statuscode</li>
            <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
            <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers.</li>
          </ul>
          Diese Daten werden zu folgenden Zwecken verarbeitet:
          <ul>
            <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website</li>
            <li>Gewährleistung einer komfortablen Nutzung unserer Website</li>
            <li>Auswertung der Systemsicherheit und -stabilität</li>
            <li>Weitere administrative Zwecke</li>
          </ul>
          Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. Unser berechtigtes Interesse ergibt sich aus den oben aufgelisteten Zwecken der Datenerhebung. In keinem Fall verwenden wir die erhobenen Daten, um Rückschlüsse auf Ihre Person zu ziehen.
        </Typography>

        {/* Continue with more sections as needed */}
      </Paper>
    </Container>
  );
};

export default Datenschutzerklaerung;
